import React from 'react'

export default function DFFilterChip({ label, active, warn, count, onClick }) {
  let bg = 'var(--df-surface-2)'
  let color = 'var(--df-ink-2)'
  if (active) { bg = 'var(--df-primary)'; color = '#fff'; }
  if (warn)   { bg = 'var(--df-warn-bg, #fff3d9)'; color = 'var(--df-warn-text, #8c5b00)'; }

  return (
    <button
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '5px 12px',
        borderRadius: 99,
        border: 'none',
        background: bg,
        color,
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'inherit',
        cursor: 'pointer',
        transition: 'background .12s, color .12s',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
      {count != null && (
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            padding: '0 5px',
            borderRadius: 99,
            background: active ? 'rgba(255,255,255,0.2)' : 'rgba(28,36,25,0.08)',
            minWidth: 16,
            textAlign: 'center',
          }}
        >
          {count}
        </span>
      )}
    </button>
  )
}
